import { Flex, Icon, FlexProps } from '@chakra-ui/react';
import { MdNoPhotography } from 'react-icons/md';

export const NoImagePlaceholder: React.FC<FlexProps> = (props) => {
    return (
        <Flex bgColor={'gray.300'} borderWidth={10} border={'solid'} borderRadius={'lg'} justify={'center'} align={'center'} {...props}>
            <Icon as={MdNoPhotography} boxSize={{ base: 16, md: 24, xl: 32 }} color={'gray.500'} />
        </Flex>
    );
};
